// @flow
import React, { Component } from 'react';
import styled from 'react-emotion';
import CopyToClipboard from 'react-copy-to-clipboard';
import { colors } from '../assets/scripts/constants';
import iconCopyUrl from '../assets/images/icon_copy_url.png';
import iconCopyUrlGreen from '../assets/images/icon_copy_url_green.png';

const openTransition = 350;

const Container = styled('span')`
  position: absolute;
  z-index: 1;
  top: 0.3em;
  left: 0.3em;
  right: auto;
  display: block;
  padding: 0.3em 0.2em 0.2em 0.3em;
  font-size: 1.2em;
  border: 0.1em solid ${colors.orange};
  border-radius: 0.3em;
  background-color: ${colors.white};
  cursor: pointer;

  > div:first-of-type {
    width: ${({ copied }) => (copied ? '18rem' : '1.6rem')};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: ${openTransition}ms;

    > button {
      margin-right: 0.2em;
      padding: 0;
      vertical-align: sub;
      border: none;
      background: transparent;
      outline: none;

      & > img {
        height: 2em;
        vertical-align: bottom;
        cursor: pointer;
      }
    }

    > span {
      display: inline;
      font-size: 0.9rem;
      vertical-align: bottom;
      background-color: ${({ copied }) =>
        copied ? 'rgba(53, 191, 0, 0.2)' : 'transparent'};
    }
  }
`;

const UrlNotification = styled('div')`
  position: absolute;
  bottom: -2.25rem;
  left: 0;
  right: 0;
  text-align: center;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.2s;
  > figure {
    display: inline-block;
    padding: 0;
    margin: 0;
    vertical-align: bottom;
    border-bottom: 0.5rem solid ${colors.white};
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
  }
  > div {
    display: inline-block;
    padding: 0.2rem 0.4rem;
    font-size: 0.8rem;
    border-radius: 0.1rem;
    background-color: white;
  }
`;

class UrlArea extends Component<
  {
    urlWithData: string,
  },
  { latestUrlCopied: string, notificationVisible: boolean }
> {
  state = { latestUrlCopied: '', notificationVisible: false };

  componentDidUpdate() {
    const { urlWithData } = this.props;
    const { latestUrlCopied } = this.state;
    if (latestUrlCopied && latestUrlCopied !== urlWithData) {
      this.clearLatestUrlCopied();
    }
  }

  notificationTimeout: TimeoutID;

  clearLatestUrlCopied() {
    this.setState({ latestUrlCopied: '' });
  }

  render() {
    const { urlWithData } = this.props;
    const { latestUrlCopied, notificationVisible } = this.state;
    const copied = latestUrlCopied === urlWithData;

    return (
      <CopyToClipboard
        text={urlWithData}
        onCopy={() => {
          this.setState({
            latestUrlCopied: urlWithData,
            notificationVisible: false,
          });
          clearTimeout(this.notificationTimeout);
          this.notificationTimeout = setTimeout(() => {
            // Show copy notification.
            this.setState({ notificationVisible: true });
            // HIde copy notification after 2s.
            this.notificationTimeout = setTimeout(
              () => this.setState({ notificationVisible: false }),
              2000
            );
          }, copied ? 0 : openTransition - 50); // Show notification instantly if URL already visible.
        }}
      >
        <Container copied={copied}>
          <div>
            <button>
              <img src={copied ? iconCopyUrlGreen : iconCopyUrl} alt="" />
            </button>
            <span>{urlWithData}</span>
          </div>
          {copied && (
            <UrlNotification visible={notificationVisible}>
              <figure />
              <br />
              <div>Kopioitu!</div>
            </UrlNotification>
          )}
        </Container>
      </CopyToClipboard>
    );
  }
}

export default UrlArea;



// WEBPACK FOOTER //
// ./src/components/UrlArea.js